import { jsx as _jsx } from "react/jsx-runtime";
import { Page } from "./Page.js";
import { MarkedContent } from "./marked/MarkedContent.js";
export function PageWithMarkdown({ bodyMarkdown, ...pageProps }) {
    return (_jsx(Page, { ...pageProps, children: bodyMarkdown && _jsx(MarkedContent, { raw: bodyMarkdown }) }));
}
